/**
 * ZEN ERP — Teklif & Sipariş Form Sabitleri + Fiyatlama Yardımcıları
 * App.js'den çıkarıldı — tüm ürün formu bileşenleri ve QuoteBuilderPage bu dosyayı kullanır.
 */
import { GROUP_EXTRAS, SINEKLIK_BOYALI_KABIN_UCRETI, SINEKLIK_AHSAP_DESEN_PCT } from "./pdfUtils";
import { lookupSkyZipPrice, lookupArtZipPrice } from "../artbeyPricing";
import { lookupBayediZipPrice } from "../bayediPricing";
import { lookupRustikPrice } from "../rustikPricing";
import { convertPrice } from "../appUtils";
import { roundRecipeWidth } from "./storRecipe";
import { tulFonMetraj } from "./tulFonSheetModel";

// ── Ürün Grubu Slug Sabitleri ─────────────────────────────────────────────────
export const METAL_JALUZI_SLUG = "metal_jaluzi_16_25";
export const DIKEY_RAY_SLUG = "dikey_ray";
// Dikey perde rayı mt fiyatları — 2024 EUR listesi (KDV %20)
export const DIKEY_RAY_PRICES = { "PVC": 14.52, "Tül": 16.25, "Kumaş": 19.50 };
export const STOR_SISTEM_SLUG = "stor_sistem";
export const SADECE_KUMAS_SLUG = "sadece_kumas";
export const SADECE_KUMAS_CARPAN = 0.65;
export const SINEKLIK_MATRIX_SLUGS = ["sineklik_dikey", "sineklik_duble_yatay", "surme_sineklik"];
// Tenteks 2026 — Giyotin Cam, Pergola, Kasetli/Mafsallı Tente, Bioklimatik, Cam Tavan, Sürme Cam Sistemi, Pencere Tentesi
export const TENTEKS_MATRIX_GROUPS = ["kasetli_tente", "mafsalli_tente", "giyotin_cam", "cam_tavan", "surme_cam_sistemi", "pergola", "bioklimatik", "pencere_tentesi"];
// Tenteks — Liste fiyatı → Satış fiyatı çarpanı: %55 iskonto + %20 kar = 0.45 × 1.20
export const TENTEKS_INSAI_KARPAN = 0.45 * 1.20; // 0.54
// Tenteks — ürün bazlı Motor/Sensör/İnşai aksesuar fiyat farkları
export const TENTEKS_ACCESSORIES = {
  kasetli_tente: {
    motor: [
      { value: "Somfy", label: "Somfy", delta: 0 },
      { value: "Simu", label: "Simu (-50 €)", delta: -50 },
    ],
    sensors: [
      { key: "ruzgarSensoru", label: "Rüzgar Sensörü", price: 170 },
      { key: "yagmurSensoru", label: "Yağmur Sensörü", price: 170 },
    ],
    sacakYazi: { listeUcreti: 120 },
  },
  mafsalli_tente: {
    motor: [
      { value: "Motorsuz", label: "Motorsuz (Standart)", delta: 0 },
      { value: "Somfy", label: "Somfy (+270 €, tekli kumanda dahil)", delta: 270 },
      { value: "Simu", label: "Simu (+230 €, tekli kumanda dahil)", delta: 230 },
    ],
    sensors: [
      { key: "ruzgarSensoru", label: "Rüzgar Sensörü", price: 170 },
      { key: "yagmurSensoru", label: "Yağmur Sensörü", price: 170 },
    ],
    sacakYazi: { listeUcreti: 120 },
  },
  giyotin_cam: {
    motor: [
      { value: "Somfy", label: "Somfy (Standart Motor)", delta: 115.2 },
    ],
    controls: [
      { value: "Becker EC 541 (Tekli Kumanda)", label: "Becker EC 541 - Tekli Kumanda (+57,60 €)", delta: 57.6 },
      { value: "Becker EC 545 (5 Kanallı Kumanda)", label: "Becker EC 545 - 5 Kanallı Kumanda (+86,40 €)", delta: 86.4 },
      { value: "Becker EC 5410 (10 Kanallı Kumanda)", label: "Becker EC 5410 - 10 Kanallı Kumanda (+153,00 €)", delta: 153.0 },
    ],
  },
  pergola: {
    motor: [
      { value: "Somfy", label: "Somfy (Standart Motor)", delta: 22.68 },
    ],
    controls: [
      { value: "Somfy 1-Kanallı Kumanda", label: "Somfy 1-Kanallı Kumanda (+51,84 €)", delta: 51.84 },
      { value: "Somfy 4-Kanallı Kumanda", label: "Somfy 4-Kanallı Kumanda (+77,76 €)", delta: 77.76 },
      { value: "Somfy 16-Kanallı Kumanda", label: "Somfy 16-Kanallı Kumanda (+137,70 €)", delta: 137.7 },
    ],
    insai: {
      alinProfili: [
        { value: "60x120", label: "Alın Profili 60×120 mm (46 €/m)", unitListPrice: 46, unit: "m" },
        { value: "120x120", label: "Alın Profili 120×120 mm (60 €/m)", unitListPrice: 60, unit: "m" },
      ],
      dikme: [
        { value: "120x120_300alt", label: "Dikme 120×120 — ≤300 cm (283 €/adet)", unitListPrice: 283, unit: "adet" },
        { value: "120x120_300ust", label: "Dikme 120×120 — >300 cm (524 €/adet)", unitListPrice: 524, unit: "adet" },
      ],
      araKayit: [
        { value: "60x120", label: "Ara Kayıt Profili 60×120 (31 €/m)", unitListPrice: 31, unit: "m" },
        { value: "100x100", label: "Ara Kayıt Profili 100×100 (57 €/m)", unitListPrice: 57, unit: "m" },
      ],
      ledKontrol: [
        { value: "acKapa", label: "LED Aç-Kapa (250 €)", unitListPrice: 250 },
        { value: "dimmer", label: "LED Dimmer (425 €)", unitListPrice: 425 },
      ],
      ekstraAsku: [
        { value: "300alt", label: "Ekstra Askı Aparatı — ≤300 cm (180 €/adet)", unitListPrice: 180, unit: "adet" },
        { value: "600alt", label: "Ekstra Askı Aparatı — ≤600 cm (312 €/adet)", unitListPrice: 312, unit: "adet" },
      ],
    },
  },
  bioklimatik: {
    motor: [
      { value: "Somfy", label: "Somfy (Standart Motor, +22,68 €)", delta: 22.68 },
    ],
    controls: [
      { value: "Tekli Kumanda", label: "Tekli Kumanda (+51,84 €)", delta: 51.84 },
      { value: "5'li Kumanda", label: "5'li Kumanda (+77,76 €)", delta: 77.76 },
      { value: "10'lu Kumanda", label: "10'lu Kumanda (+137,70 €)", delta: 137.7 },
    ],
    led: [
      { value: "SINGLE", label: "Single (+37,80 €/m)", pricePerM: 37.8 },
      { value: "RGB", label: "RGB (+43,20 €/m)", pricePerM: 43.2 },
      { value: "SINGLE+RGB", label: "Single+RGB (+54,00 €/m)", pricePerM: 54.0 },
    ],
    insai: {
      alinProfili: [
        { value: "100x100", label: "Alın Profili 100×100 mm (46 €/m)", unitListPrice: 46, unit: "m" },
        { value: "150x150", label: "Alın Profili 150×150 mm (140 €/m)", unitListPrice: 140, unit: "m" },
      ],
      dikme: [
        { value: "100x100_300alt", label: "Dikme 100×100 — ≤300 cm (188 €/adet)", unitListPrice: 188, unit: "adet" },
        { value: "100x100_300ust", label: "Dikme 100×100 — >300 cm (340 €/adet)", unitListPrice: 340, unit: "adet" },
        { value: "150x150_300", label: "Dikme 150×150 — 300 cm (865 €/adet)", unitListPrice: 865, unit: "adet" },
        { value: "150x150_300ust", label: "Dikme 150×150 — >300 cm (976 €/adet)", unitListPrice: 976, unit: "adet" },
      ],
    },
  },
  pencere_tentesi: {
    motor: [
      { value: "Somfy", label: "Somfy", delta: 0 },
      { value: "Simu", label: "Simu (-50 €)", delta: -50 },
    ],
    sensors: [
      { key: "ruzgarSensoru", label: "Rüzgar Sensörü", price: 170 },
      { key: "yagmurSensoru", label: "Yağmur Sensörü", price: 170 },
    ],
  },
};
export const SURME_KASA_FEES = { "40x40": 268.47, "50x50": 314.75, "60x60": 351.78 };
export const AHSAP_DESENLI_RENKLER = ["Altın Meşe", "Ceviz", "Antik Meşe", "Winchester Meşe", "Wenge"];

// ── Stor / Zebra Perde Aksesuar Fiyatları (TL, KDV %20) — alış × 1.5 ────────
export const STOR_MEKANIZMA_PRICES = {
  "Jumbo 38ø (200-250cm)": 300,
  "Jumbo 47ø (251-300cm)": 675,
  "Jumbo 65ø (301-400cm)": 855,
  "Jumbo 150ø (501cm+)": 2400,
};
// ── Stor Mekanizma Alış Fiyatları (USD/MT, Impex net fiyat listesi) ──────────
export const STOR_MEKANIZMA_COST_USD = {
  "Jumbo 38ø (200-250cm)": 0,    // Impex listesinde ayrıca belirtilmemiş
  "Jumbo 47ø (251-300cm)": 11,
  "Jumbo 65ø (301-400cm)": 17,
  "Jumbo 150ø (501cm+)": 44,
};
export const STOR_KASA_FARK = { "Mini Kaset": 375, "Jumbo Kaset": 480 };
export const STOR_KASA_RENGI_STANDART = ["Beyaz", "Krem", "Standart"];
export const STOR_KASA_RENGI_FARKI = 113;
export const STOR_ALT_CITA_FARK = { "Standart Metal Çıta": 188, "Delüx 5cm": 338 };
export const STOR_YAN_KANAL_TL_MT = 795;
export const STOR_ZIGIL_TL = 720;
export const STOR_ZINCIR_FARK = {
  "Metal (Parlak/Mat Krom)": 173,
  "Metal (İnci/Altın/Bronz/Antrasit/Siyah)": 338,
};
export const STOR_ETEK_FARK = {
  "E-1": 105, "E-2": 105, "E-3": 105, "E-4": 105, "E-5": 105,
  "E-6": 105, "E-7": 105, "E-8": 105, "E-9": 105, "E-10": 105,
  "E-11": 105, "E-12": 105, "E-13": 105, "E-14": 105,
  "Standart Etek (E-1..14)": 105,
  "Kale & Kubbe Etek": 195,
};
export const ZEBRA_ETEK_FARK = {
  "E-1": 143, "E-2": 143, "E-3": 143, "E-4": 143, "E-5": 143,
  "E-6": 143, "E-7": 143, "E-8": 143, "E-9": 143, "E-10": 143,
  "E-11": 143, "E-12": 143, "E-13": 143, "E-14": 143,
  "Standart Etek (E-1..14)": 143,
  "Kale & Kubbe Etek": 195,
};
export const STOR_REDUKTOR_TL = 45;
export const STOR_YAYLI_MEK_TL = 698;
export const STOR_COCUK_KILIDI_TL = 30;
export const DELUX_ELCEK_TL = 105;
export const LAZER_ETEK_PRICES = {
  "20cm": 465, "30cm": 533, "40cm": 630, "50cm": 720, "60cm": 878,
  "70cm": 983, "80cm": 1125, "90cm": 1230, "100cm": 1350,
};

// ── Kumaş Grupları ────────────────────────────────────────────────────────────
export const ZIP_KUMAS_GROUPS = ["zip_kumas_86", "zip_kumas_92", "zip_kumas_96", "zip_kumas_helio", "zip_kumas_akrilik"];
export const AKRILIK_KUMAS_GROUP = "zip_kumas_akrilik";
export const STOR_KUMAS_GROUPS = [
  // Ana gruplar (geriye dönük uyum)
  "stor_panama",
  // Blackout alt grupları
  "stor_blackout_genel", "stor_blackout_fc_ithal", "stor_blackout_dokuma", "stor_blackout_oxford",
  "stor_blackout_doku", "stor_blackout_nubuk", "stor_blackout_yaldizli", "stor_blackout_yaldizli_panama",
  "stor_blackout_screen", "stor_blackout_liyosel", "stor_blackout_fr", "stor_blackout_panama",
  "stor_blackout", // eski siparişler için geriye dönük uyum
  // Screen alt grupları
  "stor_screen_pes", "stor_screen_polyester", "stor_screen_silver", "stor_screen_sun",
  "stor_screen_sunscreen1", "stor_screen_sunscreen2", "stor_screen_sunscreen3", "stor_screen_sunscreen4",
  "stor_screen", // eski uyum
  // Polyester alt grupları
  "stor_polyester_mat", "stor_polyester_super",
  "stor_polyester", // eski uyum
  // Doğal alt grupları
  "stor_dogal_vual", "stor_dogal_liyosel", "stor_dogal_linen",
  "stor_dogal", // eski uyum
  // Yaldızlı alt grupları
  "stor_yaldizli_pastel", "stor_yaldizli_panama",
  "stor_yaldizli", // eski uyum
  // Sandy ve Sinevizyon
  "stor_sandy", "stor_sinevizyon",
  "stor_ozel", // eski uyum
];

export const FABRIC_GROUP_LABELS = {
  stor: "Diğer",
  stor_panama: "Panama",
  // Blackout
  stor_blackout: "Blackout",
  stor_blackout_genel: "Blackout — Genel",
  stor_blackout_fc_ithal: "Blackout — FC İthal",
  stor_blackout_dokuma: "Blackout — Dokuma",
  stor_blackout_oxford: "Blackout — Oxford",
  stor_blackout_doku: "Blackout — Doku",
  stor_blackout_nubuk: "Blackout — Nubuk",
  stor_blackout_yaldizli: "Blackout — Yaldızlı",
  stor_blackout_yaldizli_panama: "Blackout — Yaldızlı Panama",
  stor_blackout_screen: "Blackout — Screen",
  stor_blackout_liyosel: "Blackout — Liyosel",
  stor_blackout_fr: "Blackout — FR Alevalmaz",
  stor_blackout_panama: "Blackout — Panama",
  // Screen
  stor_screen: "Screen",
  stor_screen_pes: "Screen — Pes",
  stor_screen_polyester: "Screen — Polyester",
  stor_screen_silver: "Screen — Silver",
  stor_screen_sun: "Screen — Sun",
  stor_screen_sunscreen1: "Sunscreen 1",
  stor_screen_sunscreen2: "Sunscreen 2",
  stor_screen_sunscreen3: "Sunscreen 3",
  stor_screen_sunscreen4: "Sunscreen 4",
  // Polyester
  stor_polyester: "Polyester",
  stor_polyester_mat: "Polyester — Mat",
  stor_polyester_super: "Polyester — Süper",
  // Doğal
  stor_dogal: "Vual / Liyosel / Linen",
  stor_dogal_vual: "Vual",
  stor_dogal_liyosel: "Liyosel",
  stor_dogal_linen: "Mat Linen",
  // Yaldızlı
  stor_yaldizli: "Yaldızlı",
  stor_yaldizli_pastel: "Yaldızlı — Pastel",
  stor_yaldizli_panama: "Yaldızlı — Panama",
  // Sandy & Sinevizyon
  stor_ozel: "Özel",
  stor_sandy: "Sandy",
  stor_sinevizyon: "Sinevizyon",
  // Zip
  zip_kumas_86: "Serge Ferrari 86", zip_kumas_92: "Serge Ferrari 92", zip_kumas_96: "Serge Ferrari 96",
  zip_kumas_helio: "Helioscreen", zip_kumas_akrilik: "Akrilik",
};

// ── Ürün Grubu Alan Konfigürasyonu ────────────────────────────────────────────
export const PRODUCT_GROUP_FIELDS = {
  zip: {
    label: "Zip Perde Detayları",
    fields: ["ralCode", "cableDir", "mounting", "motor", "control"],
  },
  stor: {
    label: "Stor Detayları",
    fields: ["fabric", "controlSide", "motor", "control"],
  },
  dikey: {
    label: "Dikey Perde Detayları",
    fields: ["fabric", "controlSide", "motor", "control"],
  },
  zebra: {
    label: "Zebra Detayları",
    fields: ["fabric", "controlSide", "motor"],
  },
  ahsap_jaluzi_25: {
    label: "Ahşap Jaluzi 25mm Detayları",
    fields: ["kasaRengi", "reduktorlu", "controlSide", "cocukZigil"],
  },
  ahsap_jaluzi_50: {
    label: "Ahşap Jaluzi 50mm Detayları",
    fields: ["kasaRengi", "reduktorlu", "controlSide", "cocukZigil"],
  },
  plise14: {
    label: "PLİCELL 15mm",
    fields: [],  // Tüm alanlar ana formda; yalnızca extras paneli aktif
  },
  natty_plise: {
    label: "Natty Plise",
    fields: [],  // PLİCELL 15mm ile aynı ana form mantığı, yalnızca extras paneli aktif
  },
  plise25: {
    label: "Plise 20-25",
    // fabric mükerrer: PLİCELL 20mm kendi kumaş girişini kullanır (pf-plicell25-fabric)
    fields: ["geceGunduz", "motor"],
  },
  sineklik: {
    label: "Sineklik Detayları",
    fields: ["fabric", "controlSide"],
  },
  rustik: {
    label: "Rustik Ray Detayları",
    fields: ["rustikModel", "rustikRenk", "rayOlsunMu"],
  },
  tul_fon_perde: {
    label: "Tül & Fon Perde Detayları",
    fields: ["pileSikligi", "perdeStilit", "dikisTuru", "desen", "etek", "gorsel"],
  },
  dosemelik: {
    label: "Döşemelik Kumaş Detayları",
    // fabric + roomName mükerrer: kumaş üstteki KUMAŞ satırından, oda bilgisi alttaki
    // Oda / Etiket alanından girilir — tekrar istenmiyor (kullanıcı kararı: 21.10.2026)
    fields: [],
  },
};

export const detectGroupSlug = (productName) => {
  const p = (productName || "").toLowerCase();
  if (p.includes("kasetli tente")) return "kasetli_tente";
  if (p.includes("mafsallı") || p.includes("mafsalli") || p.includes("makaslı tente") || p.includes("makasli tente")) return "mafsalli_tente";
  if (p.includes("giyotin")) return "giyotin_cam";
  if (p.includes("cam tavan")) return "cam_tavan";
  if (p.includes("sürme cam") || p.includes("surme cam") || p.includes("hebeschiebe")) return "surme_cam_sistemi";
  if (p.includes("bioklimatik") || p.includes("skyteks")) return "bioklimatik";
  if (p.includes("pergola")) return "pergola";
  if (p.includes("pencere tentesi") || p.includes("wintent")) return "pencere_tentesi";
  if (p.includes("zip") || p.includes("art ") || p.includes("sky")) return "zip";
  if (p.includes("zebra")) return "zebra";
  if (p.includes("dikey plise sineklik") || p.includes("yatay plise sineklik") || p.includes("sineklik")) return "sineklik";
  if (p.includes("natty")) return "natty_plise";
  if (p.includes("plise 14") || p.includes("plise 15") || p.includes("cam balkon")) return "plise14";
  if (p.includes("plise")) return "plise25";
  if (p.includes("metal jaluzi")) return METAL_JALUZI_SLUG;
  if (p.includes("alüminyum jaluzi") || p.includes("aluminyum jaluzi")) return null;
  if (p.includes("ahşap") || p.includes("ahsap")) {
    if (p.includes("50")) return "ahsap_jaluzi_50";
    return "ahsap_jaluzi_25";
  }
  if (p.includes("rustik")) return "rustik";
  if (p.includes("tül") || p.includes("tul") || p.includes("fon perde")) return "tul_fon_perde";
  if (p.includes("döşemelik") || p.includes("dosemelik") || p.includes("koltuk") || p.includes("mobilya kumaş")) return "dosemelik";
  if (p.includes("dikey")) return "dikey";
  if (p.includes("stor")) return "stor";
  return "stor";
};

// ── Satır Toplamı Hesaplama — Merkezi Hesaplama Motoru ──────────────────────────
// rates = { eurToTl, usdToTl } — para birimi dönüşümü için
export function computeLineTotal(grp, w, h, qty, extra = {}, matrices = [], rates = null) {
  // Dikey perde rayı: mt bazlı fiyat (10cm yukarı yuvarlama)
  if (grp?.slug === DIKEY_RAY_SLUG) {
    const roundedW = Math.ceil((w || 0) / 10) * 10;
    const mt = roundedW / 100;
    const p = DIKEY_RAY_PRICES[extra.rayTipi] ?? 0;
    return { total: mt * p * (qty || 1), m2: mt, roundedW, roundedH: 0, unitPrice: p, currency: "EUR" };
  }
  // Kumaşsız stor sistemi: REÇETE — mt bazlı TL fiyat (31.10)
  // Yuvarlama reçete kuralı (10 cm adım; artık <2 cm ise aşağı; min 100 cm).
  // Fiyat LİSTEDEN gelir (extra.mekanizmaPrice — koda gömülü fiyat YASAK);
  // fiyat yoksa 0 fiyatla süslenmez: noPrice: true döner (İsk-3 kalıbı).
  if (grp?.slug === STOR_SISTEM_SLUG) {
    const roundedW = roundRecipeWidth(w || 0);
    const mt = roundedW / 100;
    const p = Number(extra.mekanizmaPrice);
    if (!(p > 0)) {
      return { total: 0, m2: mt, roundedW, roundedH: 0, unitPrice: 0, currency: "TL", noPrice: true };
    }
    return { total: Math.round(mt * p * (qty || 1) * 100) / 100, m2: mt, roundedW, roundedH: 0, unitPrice: p, currency: "TL" };
  }
  // Sky Zip matris fiyatlama (Artbey)
  if (grp?.slug?.startsWith("skyzip") && extra.zipModeli) {
    const { price, outOfRange, noMatrix } = lookupSkyZipPrice(extra.zipModeli, extra.fabricBrand, w || 0, h || 0);
    if (!noMatrix) {
      const listPrice = outOfRange || !price ? 0 : price;
      const discountPct = Number(extra.discountPercent) || 0;
      // MANUEL FİYAT KUTSAL: elle girilen fiyat nihai fiyattır, iskonto tekrar uygulanmaz (K8)
      const hasManual = Number(extra.manualUnitPrice) > 0;
      const unitPrice = hasManual
        ? Number(extra.manualUnitPrice)
        : (discountPct > 0 ? Math.round(listPrice * (1 - discountPct / 100) * 100) / 100 : listPrice);
      const currency = hasManual ? (extra.manualUnitCurrency || "EUR") : "EUR";
      return { total: unitPrice * (qty || 1), m2: (w * h) / 10000, roundedW: w, roundedH: h, unitPrice, listPrice, currency, outOfRange, discountPct: hasManual ? 0 : discountPct };
    }
  }
  // Zip Aksesuar — sadece adet bazlı
  if (grp?.slug === "zip_aksesuar") {
    const unitPrice = Number(extra.manualUnitPrice) || 0;
    const currency = extra.manualUnitCurrency || "EUR";
    return { total: unitPrice * (qty || 1), m2: 0, roundedW: 0, roundedH: 0, unitPrice, currency };
  }
  // Dikey Zip matris fiyatlama (Art 90/110/130/140 veya Bayedi T100/T125)
  if (grp?.slug === "zip_art110_helio" && extra.zipCesidi) {
    const isBayediDikey = ["T100", "T125"].includes(extra.zipCesidi || "");
    const artResult = isBayediDikey
      ? lookupBayediZipPrice(extra.zipCesidi, extra.fabricBrand, w || 0, h || 0)
      : lookupArtZipPrice(extra.zipCesidi, extra.fabricBrand, w || 0, h || 0);
    const { price, outOfRange, noMatrix } = artResult;
    if (!noMatrix) {
      const matrixPrice = outOfRange || !price ? 0 : price;
      const unitPrice = Number(extra.manualUnitPrice) > 0 ? Number(extra.manualUnitPrice) : matrixPrice;
      const currency = Number(extra.manualUnitPrice) > 0 ? (extra.manualUnitCurrency || "EUR") : "EUR";
      const zipIskontoOrani = isBayediDikey ? 0 : (Number(artResult?.iskontoOrani) || 0);
      const zipCostPrice  = isBayediDikey ? 0 : (artResult?.costPrice ?? matrixPrice);
      const matrixCell = artResult?.trace ? { usedWidth: artResult.trace.w, usedHeight: artResult.trace.h, basePrice: artResult.trace.cellPrice, iskontoOrani: zipIskontoOrani } : null;
      return { total: unitPrice * (qty || 1), m2: (w * h) / 10000, roundedW: w, roundedH: h, unitPrice, currency, outOfRange, costPrice: zipCostPrice, matrixCell };
    }
  }
  // Rustik Ray Sistemi (Kanallı / Ahşap / Antik & Retro) — sadece genişlik bazlı
  if (grp?.slug === "rustik" && extra.rustikTipi) {
    const rustikModel = extra.rustikTipi === "kanalli"
      ? (extra.kanallıTip || extra.kanalli_tip || "tekli")
      : extra.rustikTipi === "antik"
        ? (extra.antikBoruCapi || "30mm")
        : null;
    const info = lookupRustikPrice(extra.rustikTipi, rustikModel, w, !!extra.rayOlsunMu);
    if (!info.outOfRange) {
      // KANALLI RUSTİK: bileşen adetleri (ayak/başlık/tapa) değişince OrderForm
      // nihai toplamı manualUnitPrice'a yazıyor; matris fiyatı onu ezmemeli (K7).
      const hasManual = Number(extra.manualUnitPrice) > 0;
      const unitPrice = hasManual ? Number(extra.manualUnitPrice) : (info.satis + info.rayEkSatis);
      const currency = hasManual ? (extra.manualUnitCurrency || "TL") : "TL";
      return { total: unitPrice * (qty || 1), m2: 1, roundedW: w, roundedH: h, unitPrice, currency, outOfRange: false, rustikInfo: info };
    }
    return { total: 0, m2: 1, roundedW: w, roundedH: h, unitPrice: 0, currency: "TL", outOfRange: true };
  }
  if (TENTEKS_MATRIX_GROUPS.includes(grp?.slug)) {
    const groupMatrices = matrices.filter((m) => m.groupSlug === grp.slug);
    const mtx = groupMatrices.find((m) => m.name === extra.matrixVariant) || groupMatrices[0];
    const currency = mtx?.currency || grp?.currency || "EUR";
    const availableMatrices = groupMatrices.map((m) => m.name);
    if (mtx && w > 0 && h > 0) {
      const widths = mtx.widths || [], heights = mtx.heights || [];
      let colIdx = widths.findIndex((x) => x >= w); if (colIdx === -1) colIdx = widths.length - 1;
      let rowIdx = heights.findIndex((x) => x >= h); if (rowIdx === -1) rowIdx = heights.length - 1;
      const listPrice = mtx.prices?.[rowIdx]?.[colIdx] || 0;
      const outOfRange = !listPrice || w > widths[widths.length - 1] || h > heights[heights.length - 1];
      const iskontoOrani = Number(mtx.iskontoOrani) || 0;
      const karMarjiOrani = Number(mtx.karMarjiOrani) || 0;
      const costPrice = iskontoOrani > 0 ? listPrice * (1 - iskontoOrani / 100) : listPrice;
      let unitPrice = karMarjiOrani > 0 ? costPrice * (1 + karMarjiOrani / 100) : costPrice;
      const accessories = TENTEKS_ACCESSORIES[grp.slug];
      let accessoryDelta = 0;
      if (accessories) {
        const motorOpt = accessories.motor?.length === 1 ? accessories.motor[0] : accessories.motor?.find((m) => m.value === extra.tentMotor);
        if (motorOpt) accessoryDelta += motorOpt.delta;
        const controlOpt = accessories.controls?.find((c) => c.value === extra.tentControl);
        if (controlOpt) accessoryDelta += controlOpt.delta;
        (accessories.sensors || []).forEach((s) => { if (extra[`tentSensor_${s.key}`]) accessoryDelta += s.price; });
        const ledOpt = accessories.led?.find((l) => l.value === extra.tentLed);
        if (ledOpt) {
          const ledLengthM = ((w / 100) + (h / 100)) * 2;
          accessoryDelta += ledOpt.pricePerM * ledLengthM;
        }
        // Saçak Yazı Ücreti (kasetli + mafsallı tente)
        if (accessories.sacakYazi && extra.tentSacakYazi) {
          accessoryDelta += accessories.sacakYazi.listeUcreti * TENTEKS_INSAI_KARPAN;
        }
        // İnşai Aksesuarlar (pergola + bioklimatik)
        const insai = accessories.insai;
        if (insai) {
          const calcInsai = (items, tipKey, miktarKey, fixedMiktar) => {
            const opt = items?.find(x => x.value === extra[tipKey]);
            if (opt) {
              const qty = fixedMiktar !== undefined ? fixedMiktar : (Number(extra[miktarKey]) || 0);
              accessoryDelta += opt.unitListPrice * qty * TENTEKS_INSAI_KARPAN;
            }
          };
          calcInsai(insai.alinProfili, "tentInsaiAlinTip", "tentInsaiAlinMiktar");
          calcInsai(insai.dikme, "tentInsaiDikmeTip", "tentInsaiDikmeMiktar");
          calcInsai(insai.araKayit, "tentInsaiAraKayitTip", "tentInsaiAraKayitMiktar");
          calcInsai(insai.ledKontrol, "tentInsaiLedTip", null, 1); // sabit 1 adet
          calcInsai(insai.ekstraAsku, "tentInsaiEkstraAskuTip", "tentInsaiEkstraAskuMiktar");
        }
      }
      unitPrice += accessoryDelta;
      const matrixCell = { usedWidth: widths[colIdx], usedHeight: heights[rowIdx], colIdx, rowIdx, basePrice: listPrice, iskontoOrani, karMarjiOrani, accessoryDelta };
      return { total: unitPrice * (qty || 1), m2: (w * h) / 10000, roundedW: w, roundedH: h, unitPrice, currency, outOfRange, costPrice, matrixCell, availableMatrices, matrixVariant: mtx.name };
    }
    return { total: 0, m2: (w * h) / 10000, roundedW: w, roundedH: h, unitPrice: 0, currency, outOfRange: true, costPrice: 0, matrixCell: null, availableMatrices, matrixVariant: mtx?.name };
  }
  if (SINEKLIK_MATRIX_SLUGS.includes(grp?.slug)) {
    const mtx = matrices.find((m) => m.groupSlug === grp.slug);
    const currency = mtx?.currency || grp?.currency || "TL";
    const kasaFee = grp?.slug === "surme_sineklik" ? (SURME_KASA_FEES[extra.kasaOlcusu] || 0) : 0;
    const boyaliFee = extra.renkTipi === "boyali" ? SINEKLIK_BOYALI_KABIN_UCRETI : 0;
    const ahsapPct = extra.renkTipi === "ahsap_desenli" ? SINEKLIK_AHSAP_DESEN_PCT : 0;
    if (mtx && w > 0 && h > 0) {
      const widths = mtx.widths || [], heights = mtx.heights || [];
      let colIdx = widths.findIndex((x) => x >= w); if (colIdx === -1) colIdx = widths.length - 1;
      let rowIdx = heights.findIndex((x) => x >= h); if (rowIdx === -1) rowIdx = heights.length - 1;
      const basePrice = mtx.prices?.[rowIdx]?.[colIdx] || 0;
      const iskontoOrani = Number(mtx.iskontoOrani) || 0;
      const costPrice = iskontoOrani > 0 ? basePrice * (1 - iskontoOrani / 100) : basePrice;
      const unitPrice = basePrice * (1 + ahsapPct / 100) + kasaFee + boyaliFee;
      const matrixCell = { usedWidth: widths[colIdx], usedHeight: heights[rowIdx], colIdx, rowIdx, basePrice, iskontoOrani };
      return { total: unitPrice * (qty || 1), m2: (w * h) / 10000, roundedW: w, roundedH: h, unitPrice, currency, kasaFee, boyaliFee, ahsapPct, costPrice, matrixCell };
    }
    return { total: 0, m2: (w * h) / 10000, roundedW: w, roundedH: h, unitPrice: 0, currency, kasaFee, boyaliFee, ahsapPct, costPrice: 0, matrixCell: null };
  }
  // Tül & Fon Perde — mtül bazlı hesaplama (m² yerine metre tül)
  if (grp?.slug === "tul_fon_perde") {
    const enCm = w || 0;
    const boyCm = h || 0;
    const pileOrani = Number(extra.pileSikligi) || 2;
    const kumasEniCm = Number(extra.kumasEniCm) || 300;

    const totalMtul = tulFonMetraj(enCm, boyCm, extra).mtul;

    let unitPrice = Number(extra.fabricPrice) || 0;
    let currency = extra.fabricCurrency || "TL";
    if (Number(extra.manualUnitPrice) > 0) {
      unitPrice = Number(extra.manualUnitPrice);
      currency = extra.manualUnitCurrency || currency;
    }

    // Astarlı seçildiyse astar kumaş fiyatını ekle
    if (extra.astarli && Number(extra.astarFabricPrice) > 0) {
      const astarCur = extra.astarFabricCurrency || currency;
      const astarInMainCur = astarCur === currency
        ? Number(extra.astarFabricPrice)
        : convertPrice(Number(extra.astarFabricPrice), astarCur, currency, rates);
      unitPrice = unitPrice + astarInMainCur;
    }

    const total = totalMtul * unitPrice * (qty || 1);
    return {
      total, mtul: totalMtul, m2: totalMtul,
      roundedW: enCm, roundedH: boyCm,
      unitPrice, currency, isTulFon: true,
      pileOrani, kumasEniCm,
    };
  }
  const step = grp?.roundingStepCm || 10;
  const minW = grp?.minWidthCm || 0;
  const minH = grp?.minHeightCm || 0;
  const roundedW = Math.max(minW, Math.ceil((w || 0) / step) * step);
  const roundedH = Math.max(minH, Math.ceil((h || 0) / step) * step);
  let m2 = (roundedW * roundedH) / 10000;
  const minM2 = grp?.minM2 || 0;
  if (m2 < minM2) m2 = minM2;
  let price = grp?.basePricePerM2 || 0;
  let currency = grp?.currency || "TL";
  // Metal jaluzi: slat varyantına göre EUR m² fiyat
  if (grp?.slug === METAL_JALUZI_SLUG && Array.isArray(grp?.slatVariants)) {
    const v = grp.slatVariants.find(x => x.key === extra.slatVariantKey) || grp.slatVariants.find(x => x.size === extra.slatSize);
    if (v) { price = v.priceEUR; currency = "EUR"; }
  }
  // Kumaş bazlı fiyat — kumaşın kendi para birimi yoksa GRUBUN para birimi kullanılır (O2)
  if (Number(extra.fabricPrice) > 0) { price = Number(extra.fabricPrice); currency = extra.fabricCurrency || currency; }
  // Çiftli Sistem: ön kumaş + arka kumaş fiyatları toplanır
  if (grp?.slug === "ciftli_sistem" && (Number(extra.fabricPrice) > 0 || Number(extra.fabric2Price) > 0)) {
    price = Number(extra.fabricPrice || 0) + Number(extra.fabric2Price || 0);
    currency = extra.fabricCurrency || extra.fabric2Currency || currency;
  }
  // MANUEL FİYAT KUTSAL — elle girilen nihai birim fiyat hiçbir çarpana tabi değildir (O1)
  const hasManualUnitPrice = Number(extra.manualUnitPrice) > 0;
  if (hasManualUnitPrice) { price = Number(extra.manualUnitPrice); currency = extra.manualUnitCurrency || currency; }
  // Sadece kumaş satışı: %35 indirim (Akrilik hariç) — manuel fiyata UYGULANMAZ (O1)
  if (grp?.slug === SADECE_KUMAS_SLUG && extra.fabricGroup !== AKRILIK_KUMAS_GROUP && !hasManualUnitPrice) price = price * SADECE_KUMAS_CARPAN;
  // Grup ekstraları (EUR)
  let extrasTotal = 0;
  let extrasPct = 0;
  const extrasDef = GROUP_EXTRAS[grp?.slug];
  if (extrasDef && Array.isArray(extra.pliseExtras)) {
    for (const key of extra.pliseExtras) {
      const def = extrasDef.find(d => d.key === key);
      if (!def) continue;
      if (def.type === "m2") extrasTotal += def.price * m2;
      else if (def.type === "adet") extrasTotal += def.price;
      else if (def.type === "adet_tl") {
        // TL fiyat → sipariş para birimine çevir
        if (currency !== "TL" && rates) extrasTotal += convertPrice(def.price, "TL", currency, rates);
        else extrasTotal += def.price;
      }
      else if (def.type === "pct") extrasPct += def.pct;
      else if (def.type === "pct_renk") extrasPct += def.pct * Math.max(1, Number(extra.renkSayisi) || 1);
    }
  }
  const baseTotal = m2 * price;
  // Ahşap Jaluzi 25mm — Motorlu seçiminde 50mm Kasa fark fiyatı: $20/mt en
  if (grp?.slug === "ahsap_jaluzi_25" && extra.motor) {
    extrasTotal += 20 * (roundedW / 100);
  }
  // Ahşap Jaluzi 25mm — Zigıl Sistemi Evet: +6 EUR/adet
  if (grp?.slug === "ahsap_jaluzi_25" && extra.cocukZigil === "Evet") {
    extrasTotal += 6;
  }
  // Ahşap Jaluzi 50mm — Kurdelalı merdiven ipi: +2 EUR/m²
  if (grp?.slug === "ahsap_jaluzi_50" && extra.merdivenIpi === "Kurdelalı") {
    extrasTotal += 2 * m2;
  }
  // Ahşap Jaluzi 50mm — Redüktörlü Sistem seçilince: +3,5 EUR/m²
  if (grp?.slug === "ahsap_jaluzi_50" && extra.mekanizmaCesidi === "Redüktörlü Sistem") {
    extrasTotal += 3.5 * m2;
  }
  // Çiftli Sistem — Kapalı Kasa: +350 TL/mt (en bazlı)
  if (grp?.slug === "ciftli_sistem" && extra.kasaTipi === "Kapalı Kasa") {
    const kasaTL = 350 * (roundedW / 100);
    if (currency !== "TL" && rates) {
      extrasTotal += convertPrice(kasaTL, "TL", currency, rates);
    } else {
      extrasTotal += kasaTL;
    }
  }
  // Plise 14 / Natty Plise — Kasa Rengi ek fiyat (Beyaz/Krem hariç: +60 TL/m²)
  // DÜZELTİLDİ: 60 TL'yi sipariş para birimine (EUR vb.) çeviriyoruz
  if ((grp?.slug === "plise14" || grp?.slug === "natty_plise") && extra.kasaRengi14 && extra.kasaRengi14 !== "Beyaz" && extra.kasaRengi14 !== "Krem") {
    const kasaFeeTL = 60 * m2;
    if (currency !== "TL" && rates) {
      extrasTotal += convertPrice(kasaFeeTL, "TL", currency, rates);
    } else {
      extrasTotal += kasaFeeTL;
    }
  }
  // Natty Plise Gece-Gündüz +60 TL/m² fark kuralı kaldırıldı (Kullanıcı talebiyle)
  // Form editörü seçenek & alan fiyat kuralları (formOptionExtras)
  if (Array.isArray(extra.formOptionExtras)) {
    for (const rule of extra.formOptionExtras) {
      if (!rule?.amount) continue;
      if (rule.type === "m2")    extrasTotal += rule.amount * m2;
      else if (rule.type === "fixed") extrasTotal += rule.amount;
      else if (rule.type === "pct")   extrasPct   += rule.amount;
    }
  }
  return { total: (baseTotal * (1 + extrasPct / 100) + extrasTotal) * (qty || 1), m2, roundedW, roundedH, unitPrice: price, currency };
}

// ── Hiyerarşik Fiyatlandırma — Tüm Ürün Grupları ────────────────────────────
export const PRICE_RULE_PRODUCT_TYPES = [
  { key: "zip",        label: "Zip Perde",        sub: "Art / Sky",              color: "#38bdf8" },
  { key: "zip_bayedi", label: "Zip Perde",        sub: "T100 / T125",            color: "#818cf8" },
  { key: "stor",       label: "Stor Perde",        sub: null,                     color: "#34d399" },
  { key: "zebra",      label: "Zebra Perde",       sub: null,                     color: "#a78bfa" },
  { key: "silhouette", label: "Silhouette",        sub: null,                     color: "#e879f9" },
  { key: "jaluzi",     label: "Jaluzi",            sub: "Ahşap & Metal",          color: "#fb923c" },
  { key: "plise",      label: "Plise Perde",       sub: null,                     color: "#22d3ee" },
  { key: "dikey",      label: "Dikey Perde",       sub: null,                     color: "#2dd4bf" },
  { key: "sineklik",   label: "Sineklik",          sub: null,                     color: "#facc15" },
  { key: "tul_fon",    label: "Tül & Fon Perde",   sub: null,                     color: "#fb7185" },
  { key: "rustik",     label: "Rustik Ray",        sub: null,                     color: "#fbbf24" },
];

export const PRICE_RULE_FABRIC_GROUPS = {
  zip: [
    { key: "zip_kumas_86",     label: "Serge Ferrari 86%" },
    { key: "zip_kumas_92",     label: "Serge Ferrari 92%" },
    { key: "zip_kumas_96",     label: "Serge Ferrari 96%" },
    { key: "zip_kumas_helio",  label: "Helioscreen Serge 3%" },
    { key: "zip_kumas_akrilik",label: "Soltis 96 Akrilik" },
  ],
  zip_bayedi: [
    { key: "zip_kumas_86",     label: "Serge Ferrari 86%" },
    { key: "zip_kumas_92",     label: "Serge Ferrari 92%" },
    { key: "zip_kumas_96",     label: "Serge Ferrari 96%" },
    { key: "zip_kumas_helio",  label: "Helioscreen Serge 3%" },
  ],
  stor: [
    // ── Panama ──────────────────────────────────────────────────────────
    { key: "stor_panama",               label: "Panama" },
    // ── BlackOut ────────────────────────────────────────────────────────
    { key: "stor_blackout",             label: "═══ BlackOut ═══",        isGroupHeader: true },
    { key: "stor_blackout_genel",       label: "BlackOut · Genel" },
    { key: "stor_blackout_fc_ithal",    label: "BlackOut · FC İthal" },
    { key: "stor_blackout_dokuma",      label: "BlackOut · Dokuma" },
    { key: "stor_blackout_oxford",      label: "BlackOut · Oxford" },
    { key: "stor_blackout_doku",        label: "BlackOut · Doku" },
    { key: "stor_blackout_nubuk",       label: "BlackOut · Nubuk" },
    { key: "stor_blackout_yaldizli",    label: "BlackOut · Yaldızlı" },
    { key: "stor_blackout_yaldizli_panama", label: "BlackOut · Yaldızlı Panama" },
    { key: "stor_blackout_screen",      label: "BlackOut · Screen BO" },
    { key: "stor_blackout_liyosel",     label: "BlackOut · Liyosel" },
    { key: "stor_blackout_fr",          label: "BlackOut · FR Alevalmaz" },
    { key: "stor_blackout_panama",      label: "BlackOut · Panama" },
    // ── Screen ──────────────────────────────────────────────────────────
    { key: "stor_screen",               label: "═══ Screen ═══",          isGroupHeader: true },
    { key: "stor_screen_pes",           label: "Screen · Pes" },
    { key: "stor_screen_polyester",     label: "Screen · Polyester" },
    { key: "stor_screen_silver",        label: "Screen · Silver" },
    { key: "stor_screen_sun",           label: "Screen · Sun Screen" },
    { key: "stor_screen_sunscreen1",    label: "Sunscreen 1" },
    { key: "stor_screen_sunscreen2",    label: "Sunscreen 2" },
    { key: "stor_screen_sunscreen3",    label: "Sunscreen 3" },
    { key: "stor_screen_sunscreen4",    label: "Sunscreen 4" },
    // ── Polyester ───────────────────────────────────────────────────────
    { key: "stor_polyester",            label: "═══ Polyester ═══",       isGroupHeader: true },
    { key: "stor_polyester_mat",        label: "Polyester · Mat" },
    { key: "stor_polyester_super",      label: "Polyester · Süper" },
    // ── Doğal / Vual ────────────────────────────────────────────────────
    { key: "stor_dogal",                label: "═══ Doğal / Vual ═══",    isGroupHeader: true },
    { key: "stor_dogal_vual",           label: "Vual" },
    { key: "stor_dogal_liyosel",        label: "Liyosel" },
    { key: "stor_dogal_linen",          label: "Mat Linen" },
    // ── Yaldızlı ────────────────────────────────────────────────────────
    { key: "stor_yaldizli",             label: "═══ Yaldızlı ═══",        isGroupHeader: true },
    { key: "stor_yaldizli_pastel",      label: "Yaldızlı · Pastel" },
    { key: "stor_yaldizli_panama",      label: "Yaldızlı · Panama" },
    // ── Sandy ───────────────────────────────────────────────────────────
    { key: "stor_sandy",                label: "Sandy" },
    { key: "stor_sinevizyon",           label: "Sinevizyon" },
  ],
  zebra: [
    { key: "zebra_9000", label: "9000 — Düz Jakar" },
    { key: "zebra_9010", label: "9010 — Düz" },
    { key: "zebra_9020", label: "9020 — Bambu" },
    { key: "zebra_9030", label: "9030 — Soft Bambu" },
    { key: "zebra_9050", label: "9050 — Düz Keten" },
    { key: "zebra_9060", label: "9060 — Kırçıllı Blackout" },
    { key: "zebra_9070", label: "9070 — Lüks Jakar" },
    { key: "zebra_9080", label: "9080 — Geçişli Bambu" },
    { key: "zebra_9090", label: "9090 — Dokuma" },
    { key: "zebra_9100", label: "9100 — Native" },
    { key: "zebra_9110", label: "9110 — Black" },
    { key: "zebra_9120", label: "9120 — Mikro Simli" },
    { key: "zebra_9130", label: "9130 — Karartma" },
    { key: "zebra_9140", label: "9140 — Karartma 2" },
    { key: "zebra_9150", label: "9150 — Kırçıllı Keten" },
    { key: "zebra_9160", label: "9160 — Keten Pileli" },
    { key: "zebra_9171", label: "9171-72 — Eco Pile" },
    { key: "zebra_9173", label: "9173-74 — Eco Pile" },
    { key: "zebra_9175", label: "9175-76 — Eco Pile" },
    { key: "zebra_9180", label: "9180 — Lüks Pile" },
    { key: "zebra_9190", label: "9190 — Jakar Pile" },
    { key: "zebra_9200", label: "9200 — Naturel Pile" },
    { key: "zebra_9210", label: "9210 — Bambu Düz Pile" },
    { key: "zebra_9220", label: "9220 — Pileli Blackout" },
    { key: "zebra_9230", label: "9230 — Bambu Pile" },
    { key: "zebra_9240", label: "9240 — Jakar Pileli" },
    { key: "zebra_9250", label: "9250 — Simli Pileli" },
    { key: "zebra_9260", label: "9260 — Geçişli Pileli" },
    { key: "zebra_9270", label: "9270 — Renkli Pileli" },
    { key: "zebra_9280", label: "9280 — Baskılı Pileli" },
  ],
  jaluzi: [
    { key: "ahsap_jaluzi_25",    label: "Ahşap 25mm" },
    { key: "ahsap_jaluzi_50",    label: "Ahşap 50mm" },
    { key: "metal_jaluzi_16_25", label: "Metal 16-25mm" },
  ],
  plise: [
    { key: "plise14",            label: "PLİCELL 15mm" },
    { key: "natty_plise",        label: "Natty Plise (Genel)" },
    { key: "natty_bali",         label: "Natty Plise · Bali" },
    { key: "natty_bat",          label: "Natty Plise · Bat" },
    { key: "natty_canary",       label: "Natty Plise · Canary" },
    { key: "natty_capri",        label: "Natty Plise · Capri" },
    { key: "natty_crow",         label: "Natty Plise · Crow" },
    { key: "natty_daffodil",     label: "Natty Plise · Daffodil" },
    { key: "natty_fiji",         label: "Natty Plise · Fiji" },
    { key: "natty_lino",         label: "Natty Plise · Lino" },
    { key: "natty_mallorca_fr",  label: "Natty Plise · Mallorca FR" },
    { key: "natty_mikanos",      label: "Natty Plise · Mikanos" },
    { key: "natty_pelican",      label: "Natty Plise · Pelican" },
    { key: "natty_penguin",      label: "Natty Plise · Penguin" },
    { key: "natty_phuket",       label: "Natty Plise · Phuket" },
    { key: "natty_printed",      label: "Natty Plise · Printed" },
    { key: "natty_rose",         label: "Natty Plise · Rose" },
    { key: "natty_santorini",    label: "Natty Plise · Santorini" },
    { key: "natty_silky",        label: "Natty Plise · Silky" },
    { key: "natty_swan",         label: "Natty Plise · Swan" },
    { key: "natty_tenedos",      label: "Natty Plise · Tenedos" },
    { key: "natty_tulip",        label: "Natty Plise · Tulip" },
    { key: "natty_zanzibar",     label: "Natty Plise · Zanzibar" },
    { key: "plise25",            label: "PLİCELL 20mm" },
  ],
  dikey: [
    { key: "dikey_pvc",   label: "PVC Dikey" },
    { key: "dikey_tul",   label: "Tül Dikey" },
    { key: "dikey_kumas", label: "Kumaş Dikey" },
  ],
  tul_fon: [
    { key: "tf_tul",   label: "Tül Perde" },
    { key: "tf_fon",   label: "Fon Perde" },
    { key: "tf_havuz", label: "Havuz Tül" },
  ],
};

export function getProductTypeKey(slug, extras = {}) {
  if (!slug) return "";
  if (slug === "zip_art110_helio" || slug.startsWith("skyzip")) {
    if (["T100", "T125"].includes(extras?.zipCesidi)) return "zip_bayedi";
    return "zip";
  }
  if (slug === "tul_fon_perde") return "tul_fon";
  if (slug === "silhouette") return "silhouette";
  if (slug === "zebra") return "zebra";
  if (slug === "rustik") return "rustik";
  if (slug.startsWith("stor") || slug === "ciftli_sistem") return "stor";
  if (slug.startsWith("metal_jaluzi") || slug.startsWith("ahsap_jaluzi")) return "jaluzi";
  if (slug === "dikey" || slug === "dikey_ray") return "dikey";
  if (slug.startsWith("plise") || slug === "natty_plise") return "plise";
  if (slug.startsWith("sineklik") || slug.startsWith("surme")) return "sineklik";
  return "";
}

export function buildDealerRuleResult(rule, m2, productTotal, qty, groupName) {
  if (rule.type === "fixed") {
    const newTotal = Math.round(Number(rule.val) * (m2 || 0) * (qty || 1) * 100) / 100;
    return { total: newTotal, discountPct: 0, label: `Sabit Fiyat: ${rule.val} ${rule.currency || "EUR"}/m² (${groupName})`, fixedUnitPrice: Number(rule.val), fixedCurrency: rule.currency || "EUR" };
  }
  if (rule.type === "margin") {
    // Kâr Marjı: alış_fiyatı × (1 + kâr%)
    const pct = Number(rule.val);
    const newTotal = Math.round(productTotal * (1 + pct / 100) * 100) / 100;
    return { total: newTotal, discountPct: 0, marginPct: pct, label: `%${pct} Kâr Marjı (${groupName})` };
  }
  const pct = Number(rule.val);
  const newTotal = Math.round(productTotal * (1 - pct / 100) * 100) / 100;
  return { total: newTotal, discountPct: pct, label: `%${pct} Bayi İskontosu (${groupName})` };
}

export function applyGlobalMarginPricing(globalMargins, productTypeKey, m2, productTotal, qty) {
  if (!globalMargins || !productTypeKey) return null;
  const pct = Number(globalMargins[productTypeKey]);
  if (!pct || pct <= 0) return null;
  const newTotal = Math.round(productTotal * (1 + pct / 100) * 100) / 100;
  return { total: newTotal, discountPct: 0, marginPct: pct, label: `%${pct} Varsayılan Kâr Marjı` };
}

export function applyDealerGroupPricing(dealerGroup, productTypeKey, fabricGroup, m2, productTotal, qty) {
  if (!dealerGroup) return null;
  const rules = Array.isArray(dealerGroup.priceRules) ? dealerGroup.priceRules : [];
  if (fabricGroup) {
    const r = rules.find(x => x.slug === productTypeKey && x.fabricGroup === fabricGroup);
    if (r) return buildDealerRuleResult(r, m2, productTotal, qty, dealerGroup.name);
  }
  const r2 = rules.find(x => x.slug === productTypeKey && !x.fabricGroup);
  if (r2) return buildDealerRuleResult(r2, m2, productTotal, qty, dealerGroup.name);
  if (Number(dealerGroup.discountPct) > 0) {
    const pct = Number(dealerGroup.discountPct);
    const newTotal = Math.round(productTotal * (1 - pct / 100) * 100) / 100;
    return { total: newTotal, discountPct: pct, label: `Genel Bayi İskontosu: %${pct} (${dealerGroup.name})` };
  }
  return null;
}

export function applyCustomerPricing(customer, productTypeKey, fabricGroup, m2, productTotal, qty) {
  if (!customer) return null;
  const rules = Array.isArray(customer.priceRules) ? customer.priceRules : [];
  if (!rules.length) return null;
  if (fabricGroup) {
    const r = rules.find(x => x.slug === productTypeKey && x.fabricGroup === fabricGroup);
    if (r) return buildDealerRuleResult(r, m2, productTotal, qty, `${customer.name} · Özel Fiyat`);
    // Natty Plise seri-spesifik kural bulunamazsa, genel "natty_plise" kuralına düş
    if (fabricGroup.startsWith("natty_") && fabricGroup !== "natty_plise") {
      const rGeneral = rules.find(x => x.slug === productTypeKey && x.fabricGroup === "natty_plise");
      if (rGeneral) return buildDealerRuleResult(rGeneral, m2, productTotal, qty, `${customer.name} · Özel Fiyat`);
    }
  }
  const r2 = rules.find(x => x.slug === productTypeKey && !x.fabricGroup);
  if (r2) return buildDealerRuleResult(r2, m2, productTotal, qty, `${customer.name} · Özel Fiyat`);
  return null;
}

// Natty Plise serisi → fabricGroup anahtarı dönüştürücü
// Örn: "Canary" → "natty_canary", "Mallorca FR" → "natty_mallorca_fr"
export function nattyPliseFabricGroupKey(seriesName) {
  if (!seriesName) return "natty_plise";
  return "natty_" + seriesName.toLowerCase().replace(/\s+/g, "_").replace(/[^a-z0-9_]/g, "");
}
